<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12  d-flex justify-content-between overflow-hidden">
        <div class="col-sm-4">
          <h1 class="h3  mb-0 folot-left headerTitle">{{ t("accounts.address") }}</h1>
        </div>
        <div class="mt-2 col-sm-4">
          <button class="btn btn-primary float-right" @click="onClickCreateAddress">
            {{ t("accounts.createAddress") }}
          </button>
        </div>
      </div>

      <section class="col-lg-6 col-md-6 mb-4 mt-5" v-for="address in addresses.data" :key="address.uads_id">
        <div class="card" style="text-transform: capitalize;">
          <div class="card-header d-flex justify-content-between" style="padding: 5px;">
            <div>
              <i class="fa fa-thumb-tack fa-2x iconHad" aria-hidden="true"></i>
            </div>
            <div>
              <span v-if="address.uads_type == 'address'"> {{ t("orders.shippingAddress") }} </span>
              <span v-else-if="address.uads_type == 'cvs_pcsc'"> {{ t("orders.shop711") }} </span>
              <span v-else-if="address.uads_type == 'cvs_family'"> {{ t("orders.shopFami") }} </span>
              <span v-else-if="address.uads_type == 'cvs_hilife'"> {{ t("orders.shopHilife") }} </span>
              <span v-else-if="address.uads_type == 'cvs_okmart'"> {{ t("orders.shopOkmart") }} </span>
              <span v-else> {{ address.uads_type }} </span>

              <span v-if="address.is_default" class="badge badge-success ml-2">{{ t("global.default") }}</span>
            </div>
            <div class="d-flex justify-content-between">
              <a @click="onClickEditAddress(address)">
                  <i class="fa fa-edit fa-lg"></i>
              </a>

              <a @click="deleteAddress(address.uads_id)">
                  <i class="fa fa-trash fa-lg"></i>
              </a>
            </div>
          </div>
          <div class="card-body" style="padding: 0 15px 15px 13px;">
              <div class="font-name">
                <span>{{ address.to_name }}</span>
              </div>
              <div>
                <span class="font-nameA"> <strong>{{ t("users.tel") }} :</strong>  {{ address.to_mobile }}</span>
              </div>
              <div v-if="address.uads_type == 'address'">
                <span class="font-nameA"> <strong>{{ t("users.postcode") }} :</strong> {{ address.postcode }}</span>
              </div>
              <div v-if="address.uads_type == 'address'">
                <span class="font-nameA"> <strong>{{ t("users.address") }} :</strong> {{ address.province }}{{ address.city }}{{ address.address }}</span>
              </div>
              <div v-if="address.uads_type == 'cvs_pcsc' || address.uads_type == 'cvs_family' || address.uads_type == 'cvs_hilife' || address.uads_type == 'cvs_okmart'">
                  <span class="font-nameA"> <strong>{{ t("orders.mart") }} :</strong> {{ address.shop.shop_name }}</span>
              </div>
              <div v-if="address.uads_type == 'cvs_pcsc' || address.uads_type == 'cvs_family' || address.uads_type == 'cvs_hilife' || address.uads_type == 'cvs_okmart'">
                  <span class="font-nameA"> <strong>{{ t("users.address") }} :</strong> {{ address.shop.shop_address_full }}</span>
              </div>
          </div>
        </div>
      </section>
    </div>
    <el-dialog
      v-model="dialogState.visible"
      ref="dialogState.data"
      :title="isEdit ? t('accounts.editAddress') : t('accounts.createAddress')"
      width="80%"
      destroy-on-close
      @closed="handleClose(ruleFormRef)"
    >
      <el-form
        ref="ruleFormRef"
        :model="dialogState.data"
        :rules="rules"
        label-width="120px"
        size="large"
        :label-position="labelPosition"
      >
        <el-form-item :label="t('global.type')">
          <el-radio-group v-model="dialogState.data.uads_type" :disabled="isEdit">
            <el-radio border label="address">{{ t("orders.shippingAddress") }}</el-radio>
            <el-radio border label="cvs_pcsc">{{ t("orders.shop711") }}</el-radio>
            <el-radio border label="cvs_family">{{ t("orders.shopFami") }}</el-radio>
            <el-radio border label="cvs_hilife">{{ t("orders.shopHilife") }}</el-radio>
            <el-radio border label="cvs_okmart">{{ t("orders.shopOkmart") }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="t('orders.toName')" prop="to_name">
          <el-input v-model="dialogState.data.to_name" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <el-form-item :label="t('orders.toPhone')" prop="to_mobile">
          <el-input v-model="dialogState.data.to_mobile" maxlength="20" show-word-limit></el-input>
        </el-form-item>

        <!-- 宅配 -->
        <ToHome
          v-model="dialogState.data"
          v-model:state="state"
          :used-logistic-types="dialogUsedLogisticTypes"
          :provice-map="proviceMap"
          :is-edit="isEdit"
        ></ToHome>
        <!-- 711門市 -->
        <ToCvs711
          v-model:form="dialogState.data"
          v-model:state="state"
          :used-logistic-types="dialogUsedLogisticTypes"
          :is-edit="isEdit"
        ></ToCvs711>
        <!-- 全家門市 -->
        <ToCvsFamily
          v-model:form="dialogState.data"
          v-model:state="state"
          :used-logistic-types="dialogUsedLogisticTypes"
          :is-edit="isEdit"
        ></ToCvsFamily>
        <!-- 萊爾富門市 -->
        <ToCvsHilife
          v-model:form="dialogState.data"
          v-model:state="state"
          :used-logistic-types="dialogUsedLogisticTypes"
          :is-edit="isEdit"
        ></ToCvsHilife>
        <!-- OK門市 -->
        <ToCvsOkmart
          v-model:form="dialogState.data"
          v-model:state="state"
          :used-logistic-types="dialogUsedLogisticTypes"
          :is-edit="isEdit"
        ></ToCvsOkmart>

      </el-form>

      <template #footer>
        <span class="dialog-footer d-flex justify-content-end">
          <div class="mr-3">
            {{ t("global.default") }}
            <el-switch v-model="dialogState.data.is_default" />
          </div>
          <el-button @click="dialogState.visible = false">{{ t("global.cancel") }}</el-button>

          <el-button type="primary" @click="executeSubmit(ruleFormRef)">
            {{ t("global.ok") }}
          </el-button>
        </span>
      </template>
    </el-dialog>

  </div>
</template>

<script setup>
import { reactive, computed, onMounted, ref } from 'vue'
import { useI18n } from "vue-i18n"
import { breakpoint, notificationErrors } from "../../utils"
import { ElNotification } from 'element-plus'
import { _api_getAddresses, _api_postAddress, _api_putAddress, _api_deleteAddress } from "../../api/index.js"
import ToHome from '../checkout/ToHome.vue'
import ToCvs711 from '../checkout/ToCvs711.vue'
import ToCvsFamily from '../checkout/ToCvsFamily.vue'
import ToCvsHilife from '../checkout/ToCvsHilife.vue'
import ToCvsOkmart from '../checkout/ToCvsOkmart.vue'

const props = defineProps({
  country: String,
})

const { t, locale } = useI18n()

const isEdit = computed(() => dialogState.uads_id != null)
const isMobile = computed(() => breakpoint.value.xs)
const labelPosition = computed(() => isMobile.value ? "top" : "right")

const ruleFormRef = ref()
const rules = reactive({
  to_name: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toName")]), trigger: 'blur' },
  ],
  to_mobile: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toPhone")]), trigger: 'blur' },
  ],
  province: [
    { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
  ],
  city: [
    { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
  ],
  region: [
    { required: true, message: t('errors.pleaseSelect', [t("users.region")]), trigger: 'change' },
  ],
  postal_code: [
    { required: true, message: t('errors.pleaseInput', [t("users.postcode")]), trigger: 'blur' },
  ],
  address: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toAddress")]), trigger: 'blur' },
  ],
  cvs_711_shop_form: {
    province: [
      { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
    ],
    distinct: [
      { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
    ],
    road: [
      { required: true, message: t('errors.pleaseSelect', [t("users.road")]), trigger: 'change' },
    ],
  },

  cvs_711_shop_id: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.mart")]), trigger: 'change' },
  ],
  cvs_family_shop_form: {
    province: [
      { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
    ],
    distinct: [
      { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
    ],
    road: [
      { required: true, message: t('errors.pleaseSelect', [t("users.road")]), trigger: 'change' },
    ],
  },
  cvs_family_shop_id: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.mart")]), trigger: 'change' },
  ],
  cvs_hilife_shop_form: {
    province: [
      { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
    ],
    distinct: [
      { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
    ],
    road: [
      { required: true, message: t('errors.pleaseSelect', [t("users.road")]), trigger: 'change' },
    ],
  },
  cvs_hilife_shop_id: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.mart")]), trigger: 'change' },
  ],
  cvs_okmart_shop_form: {
    province: [
      { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
    ],
    distinct: [
      { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
    ],
    road: [
      { required: true, message: t('errors.pleaseSelect', [t("users.road")]), trigger: 'change' },
    ],
  },
  cvs_okmart_shop_id: [
    { required: true, message: t('errors.pleaseSelect', [t("orders.mart")]), trigger: 'change' },
  ],
})

const filterParams = reactive({
})

const addresses = reactive({
	data: [],
})

const state = reactive({
  countryMap: null,
  // 711門市
  cvs_711_provinces: [],
  cvs_711_distincts: [],
  cvs_711_roads: [],
  cvs_711_shops: [],

  // 全家門市
  cvs_family_provinces: [],
  cvs_family_distincts: [],
  cvs_family_roads: [],
  cvs_family_shops: [],

  // 萊爾富門市
  cvs_hilife_provinces: [],
  cvs_hilife_distincts: [],
  cvs_hilife_roads: [],
  cvs_hilife_shops: [],

  // OK門市
  cvs_okmart_provinces: [],
  cvs_okmart_distincts: [],
  cvs_okmart_roads: [],
  cvs_okmart_shops: [],
})

const dialogState = reactive({
  visible: false,
  uads_id: null,
  data: {
    uads_type: 'address',
    to_name: null,
    to_mobile: null,
    country: props.country,
    province: null,
    city: null,
    region: null,
    postal_code: null,
    address: null,
    cvs_711_shop_id: null,
    cvs_family_shop_id: null,
    cvs_hilife_shop_id: null,
    cvs_okmart_shop_id: null,
    cvs_711_shop_form: {
      province: null,
      distinct: null,
      road: null,
    },
    cvs_family_shop_form: {
      province: null,
      distinct: null,
      road: null,
    },
    cvs_hilife_shop_form: {
      province: null,
      distinct: null,
      road: null,
    },
    cvs_okmart_shop_form: {
      province: null,
      distinct: null,
      road: null,
    },
  },
})
const dialogUsedLogisticTypes = computed(() => {
  const logistic_types = [];
  if (dialogState.data.uads_type == 'address') {
    return ['TCAT','PERSONALLY', 'MUNETEX']
  }
  else if (dialogState.data.uads_type == 'cvs_pcsc') {
    return ['C2CUNIMART', 'B2CUNIMART']
  }
  else if (dialogState.data.uads_type == 'cvs_family') {
    return ['C2CFAMI', 'B2CFAMI']
  }
  else if (dialogState.data.uads_type == 'cvs_hilife') {
    return ['C2CHILIFE', 'B2CHILIFE']
  }
  else if (dialogState.data.uads_type == 'cvs_okmart') {
    return ['C2COKMART']
  }
  return []
});

const handleClose = (formEl) => {
  Object.assign(state, {
    cvs_711_provinces: [],
    cvs_711_distincts: [],
    cvs_711_roads: [],
    cvs_711_shops: [],
    cvs_family_provinces: [],
    cvs_family_distincts: [],
    cvs_family_roads: [],
    cvs_family_shops: [],
    cvs_hilife_provinces: [],
    cvs_hilife_distincts: [],
    cvs_hilife_roads: [],
    cvs_hilife_shops: [],
    cvs_okmart_provinces: [],
    cvs_okmart_distincts: [],
    cvs_okmart_roads: [],
    cvs_okmart_shops: [],
  })
  formEl.clearValidate()
}

const onClickCreateAddress = () => {
  dialogState.uads_id = null
  dialogState.data = {
    uads_type: 'address',
    to_name: null,
    to_mobile: null,
    country: props.country,
    province: null,
    city: null,
    region: null,
    postal_code: null,
    address: null,
    cvs_711_shop_id: null,
    cvs_family_shop_id: null,
    cvs_hilife_shop_id: null,
    cvs_okmart_shop_id: null,
    cvs_711_shop_form: {
      province: null,
      distinct: null,
      road: null,
    },
    cvs_family_shop_form: {
      province: null,
      distinct: null,
      road: null,
    },
    cvs_hilife_shop_form: {
      province: null,
      distinct: null,
      road: null,
    },
    cvs_okmart_shop_form: {
      province: null,
      distinct: null,
      road: null,
    },
  }
  dialogState.visible = true
}

const onClickEditAddress = (item) => {
  dialogState.uads_id = item.uads_id
  dialogState.data.uads_type = item.uads_type
  dialogState.data.to_name = item.to_name
  dialogState.data.to_mobile = item.to_mobile
  dialogState.data.country = item.iso_country
  dialogState.data.province = item.iso_province
  dialogState.data.city = item.iso_city
  dialogState.data.region = item.iso_region
  dialogState.data.address = item.address
  dialogState.data.postal_code = item.postcode
  dialogState.data.is_default = item.is_default

  if (dialogState.data.uads_type == 'cvs_pcsc') {
    dialogState.data.cvs_711_shop_id = item.cvs_shop_id
    dialogState.data.cvs_711_shop_form.province = item.shop.shop_province
    dialogState.data.cvs_711_shop_form.distinct = item.shop.shop_distinct
    dialogState.data.cvs_711_shop_form.road = item.shop.shop_road
  }
  else if (dialogState.data.uads_type == 'cvs_family') {
    dialogState.data.cvs_family_shop_id = item.cvs_shop_id
    dialogState.data.cvs_family_shop_form.province = item.shop.shop_province
    dialogState.data.cvs_family_shop_form.distinct = item.shop.shop_distinct
    dialogState.data.cvs_family_shop_form.road = item.shop.shop_road
  }
  else if (dialogState.data.uads_type == 'cvs_hilife') {
    dialogState.data.cvs_hilife_shop_id = item.cvs_shop_id
    dialogState.data.cvs_hilife_shop_form.province = item.shop.shop_province
    dialogState.data.cvs_hilife_shop_form.distinct = item.shop.shop_distinct
    dialogState.data.cvs_hilife_shop_form.road = item.shop.shop_road
  }
  else if (dialogState.data.uads_type == 'cvs_okmart') {
    dialogState.data.cvs_okmart_shop_id = item.cvs_shop_id
    dialogState.data.cvs_okmart_shop_form.province = item.shop.shop_province
    dialogState.data.cvs_okmart_shop_form.distinct = item.shop.shop_distinct
    dialogState.data.cvs_okmart_shop_form.road = item.shop.shop_road
  }
  // console.log("onClickEditAddress: ", dialogState.data)
  // console.log("item: ", item)

  dialogState.visible = true
}

const getData = async () => {
  window.fullPageLoading("show")
  try {
    const resp = await _api_getAddresses(filterParams)
    addresses.data = resp.data
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}

const executeSubmit = async (formEl) => {
  if (!formEl) return

  await formEl.validate((valid, fields) => {
    if (valid) {
      if (isEdit.value) {
        editAddress()
      } else {
        createAddress()
      }
    }
  })
}

const createAddress = async () => {
  window.fullPageLoading("show")
  try {
    await _api_postAddress(dialogState.data)
    dialogState.visible = false
    getData()
    ElNotification({
      title: t("accounts.createAddressSuccess"),
      type: 'success',
      position: 'bottom-left',
    })
  } catch (err) {
    console.log("createAddress Fail: ", err)
    notificationErrors(err.response.data)
  } finally {
    window.fullPageLoading("hide")
  }
}

const editAddress = async () => {
  window.fullPageLoading("show")
  try {
    await _api_putAddress(dialogState.uads_id, dialogState.data)
    dialogState.visible = false
    getData()
    ElNotification({
      title: t("accounts.updateAddressSuccess"),
      type: 'success',
      position: 'bottom-left',
    })
  } catch (err) {
    console.log("editAddress Fail: ", err)
    notificationErrors(err.response.data)
  } finally {
    window.fullPageLoading("hide")
  }
}

const deleteAddress = (uads_id) => {
  swal.fire({
    title: t("global.areYouSure"),
    text: t("accounts.deleteAddress"),
    type: 'warning',
    showCancelButton: true,
    cancelButtonText: t("global.close"),
    confirmButtonText: t("global.confirmDelete"),
  }).then(async (result) => {
    if (result.value) {
    	window.fullPageLoading("show")
      try {
        await _api_deleteAddress(uads_id)
        getData()
        ElNotification({
          title: t("accounts.removeAddressSuccess"),
          type: 'success',
          position: 'bottom-left',
        })
      } catch (err) {
        console.log("deleteAddress Fail: ", err)
        notificationErrors(err.response.data)
      } finally {
        window.fullPageLoading("hide")
      }
    }
  })
}

const setCountryMap = (country) => {
  if (country) {
    const country_code = country.toLowerCase()
    axios({
      method: 'GET',
      url: "/api/v1/data/iso-3166-ext/"+country_code,
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => {
      // console.log(res)
      state.countryMap = res.data
    })
    .catch((err) => {
      return Promise.reject(err.response)
    })
  } else {
    state.countryMap = null
  }
}

const proviceMap = computed(() => {
  if (dialogState.data.country) {
    return state.countryMap?.province || {};
  }
  return {};
});

onMounted(() => {
  getData()
  setCountryMap(props.country)
})
</script>